import type { ReactNode } from 'react';
import type { Targetable } from '~/onboarding/types';

// TODO: unify with Position
export type Directions = 'bottom' | 'left' | 'right' | 'top';

export type SharedTooltipProps = Targetable & {
  children?: ReactNode;
  /**
   * What direction should the tooltip reveal
   */
  direction: Directions;
  /**
   * Adds button to dismiss the tooltip, and handles what to do on dismissal
   */
  onDismiss?: () => void;
  /**
   * Whether or not the tooltip should display on initial render
   */
  startActive?: boolean;
  /**
   * Whether or not to hide the tooltip when the user clicks outside of it
   */
  hideOnClickOutside?: boolean;
};

export const TARGET_CLICK = 'TargetClick';
